import React, { useMemo, useState } from 'react'
import { Box, IconButton, Tooltip, Typography } from '@mui/material'


import dayjs from 'dayjs'

import RenderAction from './renderaction';
import RenderDetail from './renderdetail';

import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import DownloadIcon from "@mui/icons-material/Download"
import PersonIcon from "@mui/icons-material/Person"

import { RenderVoiceActions, platformIcon } from '../../Report/NewDetailedRegister/contact_graph_exception';

import api from "../../../api"
import { getSession } from "../../../auth"

export const actions = {
    'WHATSAPP': (...params) => ({ name: 'Atendimento Whatsapp', actions: ['download', 'see', 'delete'], detail: 'messages', filter:true }),
    'TELEGRAM': (...params) => ({ name: 'Atendimento telegram', actions: ['download', 'see', 'delete'], detail: 'messages', filter:true }),
    'INSTAGRAM': (...params) => ({ name: 'Atendimento Instagram', actions: ['download', 'see', 'delete'], detail: 'messages', filter:true }),
    'MESSENGER': (...params) => ({ name: 'Atendimento Messenger', actions: ['download', 'see', 'delete'], detail: 'messages', filter:true }),
    'INSTANTCHAT': (...params) => ({ name: 'Atendimento Web', actions: ['download', 'see', 'delete'], detail: 'messages', filter:true }),
    'EMAIL': (...params) => ({ name: 'Troca de E-mails', actions: ['download', 'see', 'delete'], detail: 'messages', filter:true }),
    'WHATSAPP_ATIVO': (...params) => ({ name: 'Contato ativo de whatsapp', actions: ['download', 'see'], detail: 'messages', filter:true }),
    'MSTEAMS': (...params) => ({ name: 'Atendimento Msteams', actions: ['download', 'see', 'delete'], detail: 'messages', filter:true }),
    'INSTANTVOICE': (...params) => ({ name: 'Conversa telefônica', actions: ['downloadvoice'], detail: 'inout', filter:true }),
    'SMS': (...params) => ({ name: 'SMS disparado', actions: ['download', 'see', 'delete'], detail: 'messages', filter:true }),
    'API': (...params) => ({ name: 'Registro da api', actions: ['download', 'see'], detail: 'messages' }),
    'INTEGRATION': (...params) => ({ name: 'Registro de integração', actions: ['download', 'see'], detail: 'messages' }),
    'AUTOMATION': (...params) => ({ name: 'Registro de automação', actions: ['download', 'see'], detail: 'messages' }),
    'SCOUT': (...params) => ({ name: 'Último contato scout', actions: ['movescout'], detail: 'scout_last_message', filter:true }),
    'STATUS_UPDATE': (...params) => ({ name: 'Atualização status', actions: [], detail: 'status_update' }),
    'OPPORTUNITY_UPDATED': (...params) => ({ name: 'Atualização', actions: [], detail: 'opportunity_update' }),
    'OPPORTUNITY_CREATED': (...params) => ({ name: 'Oportunidade criada', actions: [] }),
    'OPPORTUNITY_CHAT': (...params) => ({ name: 'Conversa', actions: ['see'], detail: 'messages' }),
    'OPPORTUNITY_COMMENT': ({data}) => ({ name: `Comentário - ${data.opportunity_name}`, actions: ['delete', 'edit', 'viewopportunity'], detail: 'opportunity_comment', owner: true, filter:true }),
    'OPPORTUNITY': ({data}) => ({name: data?.title, actions:['viewopportunity'], detail: 'opportunity_details', owner: true}),
    'WHATSAPP_VOICE': (...params) => ({ name: 'Conversa telefônica WhatsApp', actions: ['downloadvoice'], detail: 'inout', filter:true }),
}

const generateDateV2 = (value) => {
    const date = dayjs(value).local().format('MMMM DD, YYYY')
    return date[0].toLocaleUpperCase() + date.slice(1, date.length)
}

const generateTime = (value) => {
    return value.substr(0, 5)
}

const renderCreatedAt = (created_at) => {
    const created = dayjs.utc(created_at).local()
    const localDate = created.format('MMMM DD, YYYY')
    const localTime = created.format("HH:mm")
    return `${localTime} - ${localDate}`
}

const HistoricRow = ({ data, contact, setParent, initialCollapse = true, editMode }) => {

    const [collapse, setCollapse] = useState(initialCollapse)

    const component = useMemo(() => {
        if (data.platform_entrypoint && actions[data.platform_entrypoint])
            return actions[data.platform_entrypoint]({ data, contact })
        console.warn(`No action set for ${data.platform_entrypoint}.`)
        return null
    }, [data.platform_entrypoint, data, contact])

    const voiceActionRow = useMemo(() => {
        if (component?.detail !== 'inout')
            return null

        const sessionAccountCode = getSession()?.profile?.enterprise?.accountcode || ''
        const accountcode = data?.accountcode || sessionAccountCode
        const row = {
            ...data,
            accountcode,
            status: data?.status || 'Atendida',
            uniqueid: data?.uniqueid || String(data?.id || ''),
            date: data?.date,
            time: data?.time,
            destination: data?.destination || data?.origin || '',
            leg: data?.leg ?? 0
        }

        const hasMessageSource = typeof row.messages === 'string' && row.messages.trim() !== ''
        const needsMessageFallback = !hasMessageSource || Array.isArray(row.messages)
        if (needsMessageFallback && row.uniqueid && row.date && row.destination && row.accountcode) {
            const normalizedDate = String(row.date).replaceAll('-', '')
            const normalizedDestination = String(row.destination)
                .replace(/^\+55/, '0')
                .replaceAll('+', '')
            const callType = (row.custom_field2_value || row.type) === 'Entrante' ? 'inbound' : 'outbound'
            const exportPath = `/export/${row.accountcode}/${callType}/${normalizedDate}/${row.accountcode}_${normalizedDestination}/${row.uniqueid}.WAV`
            row.messages = btoa(exportPath)
        }

        return row
    }, [component?.detail, data])

    return (
        <>
            {component &&
                <Box className='historic-row-mainbox'>
                    <Box className='historic-row-icon'>
                        <span class='historic-row-icon-svg'>{platformIcon(data.platform_entrypoint)}</span>
                        <span class='historic-row-segment-line'></span>
                    </Box>
                    <Box className='historic-row-mainbody'>
                        <Box className='historic-row-header'>
                            <Box className="historic-row-title">
                                <Typography variant="subtitle1" component="div" fontWeight={600}>
                                    {component.name}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {data.journey_name}
                                </Typography>
                            </Box>
                            <Box className='historic-time-actions'>
                                {component?.detail != "inout" && !data.chatmode &&
                                    <IconButton sx={{ width: '2.5rem' }} onClick={() => setCollapse(p => !p)}>{collapse ? <AddIcon /> : <RemoveIcon />}</IconButton>
                                }
                                {component?.detail == "inout" &&
                                    <>
                                        <RenderVoiceActions row={voiceActionRow} />
                                    </>
                                }
                                {Boolean(data.created_at) &&
                                    <Box>
                                        {dayjs.utc(data.created_at).local().format('DD/MM/YYYY HH:mm')}
                                    </Box>
                                }
                                {data?.owner_name &&
                                    <Box sx={{ display: "flex", gap: 1, alignItem: "center" }}>
                                        <PersonIcon fontSize="small" />
                                        {data.owner_name}
                                    </Box>
                                }
                                {data?.account &&
                                    <Box>
                                        {data.account?.name} - {data.instancename.split('_').at(-1)}
                                    </Box>
                                }
                                {component?.detail !== "inout" &&
                                    <Box className='historic-row-actions'>
                                        {component?.actions && component.actions.map(action => (
                                            <RenderAction action={action} data={data} contact={contact} setParent={setParent} editMode={editMode} />
                                        ))}
                                    </Box>
                                }
                            </Box>
                        </Box>
                        {!collapse && component?.detail && !data.chatmode &&
                            <Box className={`historic-row-details ${component?.detail}`}>
                                {component?.detail &&
                                    <RenderDetail detail={component.detail} data={data} contact={contact} editMode={editMode} />
                                }
                            </Box>
                        }
                    </Box>
                </Box>
            }
        </>
    )
}

export default HistoricRow